import { dataPieChart } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPieChart = /*#__PURE__*/createIcon(dataPieChart)
export default IconPieChart
